
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from 'lucide-react';

interface StudioCardSkeletonProps {
  count?: number;
}

export const StudioCardSkeleton: React.FC<StudioCardSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {[...Array(count)].map((_, i) => (
        <Card key={i} className="bg-card/50 backdrop-blur-sm">
          <CardContent className="p-4 flex flex-col gap-2 h-32 items-center justify-center">
            <Loader2 className="h-5 w-5 animate-spin text-zinc-400" />
            <p className="text-sm text-zinc-400">Lädt Studios...</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
